export interface CmsApplianceDetailsModelSerialApplianceExists {
  title: string;
  body: string;
}
